export const environment = {
    production: false,
    serverUrl: 'https://q2y5km93a5.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'kcasqpcr-dev-upload',
    userPool: {
      UserPoolId: 'us-east-2_gMYlT4VnC',
      ClientId: '578ahqh2f4i7fclm2v3grdboq6',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:19a84475-c55d-4a89-8ec4-47e80fcb51d7',
    buckets: {
      'us-east-2': 'kcasqpcr-dev-upload'
    },
    modules: {
      key: 'analysisType',
      values: [
          {
            'name': 'qPCR',
            'desc': 'qPCR'
          },
          {
            'name': 'AP',
            'desc': 'A&P Regression'
          }
      ]
  },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId: 'us-east-2:19a84475-c55d-4a89-8ec4-47e80fcb51d7', // REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_gMYlT4VnC', // OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '578ahqh2f4i7fclm2v3grdboq6', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'kcasqpcr-dev-upload',
        region: 'us-east-2', // OPTIONAL -  Amazon service region
      }
    }
  };
  const awsconfig = {
    'aws_project_region': 'us-east-2',
    'aws_cognito_region': 'us-east-2',
    'aws_user_pools_id': 'us-east-2_gMYlT4VnC',
    'aws_user_pools_web_client_id': '578ahqh2f4i7fclm2v3grdboq6',
    'aws_cognito_mfa_configuration': 'OPTIONAL',

  };
  export default awsconfig;